import { Tooltip } from "@material-ui/core";
import React from "react";

const CircleColor = ({
  background,
  title,
  size = "small",
  selected,
  className,
}) => {
  const pattern = background.charAt(0) === "#" ? false : true;
  const default_back_color = "#f8f9fb";
  return (
    <Tooltip title={title || ""} className="border-0">
      <div
        key={title}
        className={`circleColor border-0
          ${size}
          pattern-${pattern}
          ${className}
          ${selected && "colorSelected"}
        `}
        style={{
          backgroundColor:
          !pattern ? background : default_back_color,
        }}
      >
        {pattern && <img src={background} alt={title || ''}/>}
      </div>
    </Tooltip>
  );
};

export default CircleColor;
